import * as React from "react";
import { forwardRef } from "react";
const SvgConversationsMenuIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 26, height: 26, viewBox: "0 0 26 26", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M11.324 12.656H5.351l1.6-1.266h4.81l2.349 1.84v-1.84h2.565V3.8H14.11V2.531h3.848v10.125h-2.566v3.223zm-8.758-.632v-1.9H0V0h12.826v10.125H6.633l-3.026 2.393-1.042.83zM1.282 8.859h2.566V10.7L6.012 9l.18-.138h5.352V1.265H1.282z", transform: "translate(4 5)", stroke: "transparent", strokeMiterlimit: 10, fill: "#fff" }));
const ForwardRef = forwardRef(SvgConversationsMenuIcon);
export { ForwardRef as ReactComponent };
